import { enum_ } from 'valibot'

export enum JwtTokenType {
  ACCESS = 2,
  REFRESH = 3,
}

export const JwtTokenTypeSchema = enum_(JwtTokenType, 'Invalid JWT Token Type')
